import type { DeliveryResponse } from "@/forwards2/forwardsTypes";
import { uniqBy } from "lodash-es";

type Translate = (key: string, values?: Record<string, string>) => string;

/** What a correction changes; the caveats depend on which of the two moved. */
export interface CorrectionChange {
  priceChanged: boolean;
  windowChanged: boolean;
}

/**
 * What a correction of a shipped or voided delivery leaves as it was, in the viewer's language. The
 * backend decides which caveats apply (`correction_caveats`); this only picks the ones for the fields
 * that moved, so they show as soon as a correction is typed.
 */
export function correctionCaveats(
  t: Translate,
  delivery: Pick<DeliveryResponse, "correction_caveats">,
  change: CorrectionChange
): string[] {
  const caveats = delivery.correction_caveats;
  if (caveats === null) return [];
  const applying = uniqBy(
    [
      ...(change.priceChanged ? caveats.price : []),
      ...(change.windowChanged ? caveats.window : []),
    ],
    "kind"
  );
  return applying.map((caveat) =>
    t(`forwards.deals.correction.${caveat.kind}`, {
      number: caveat.invoice_number ?? "",
    })
  );
}
